// extractions/action.js
import * as actionTypes from './actionTypes';

export const loadExtPageData = () => ({
  type: actionTypes.LOAD_EXT_PAGE_DATA
});

export const loadCustomColumnOptions = () => ({
  type: actionTypes.LOAD_CUSTOM_COLUMN_OPTIONS
});

export const setExtractionData = (payload) => ({
  type: actionTypes.SET_EXTRACTION_DATA,
  payload,
});

export const setStepVal = (payload) => ({
  type: actionTypes.SET_STEP_VAL,
  payload,
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});

export const setFullDataFilters = (payload) => ({
  type: actionTypes.SET_FULL_DATA_FILTERS,
  payload,
});

export const createExtraction = (payload) => ({
  type: actionTypes.CREATE_EXTRACTION,
  payload
});

export const updateExtraction = (payload) => ({
  type: actionTypes.UPDATE_EXTRACTION,
  payload
});

export const setExtErrors = (payload) => ({
  type: actionTypes.SET_EXT_ERRORS,
  payload,
});

export const setViewData = (payload) => ({
  type: actionTypes.SET_VIEW_DATA,
  payload
})

export const resetExtractionForm = () => ({
  type: actionTypes.RESET_FORM,
});

export const getExtractions = (params) => ({
  type: actionTypes.GET_EXTRACTIONS,
  params
});

export const getColumnListValues = () => ({
  type: actionTypes.GET_COLUMN_LIST_VALUES
});

export const getFieldValueOptions = (payload) => ({
  type: actionTypes.GET_FIELD_VALUE_OPTIONS,
  payload
});

export const loadExtraction = (payload) => ({
  type: actionTypes.LOAD_EXTRACTION,
  payload
});

export const resetQueryBuilder = () => ({
  type: actionTypes.RESET_QUERY_BUILDER
});

export const setQBErrors = (payload) => ({
  type: actionTypes.SET_QB_ERRORS,
  payload
});

export const moveToNextWorkflowStep = (extractionId) => ({
  type: actionTypes.NEXT_WORKFLOW_STEP,
  extractionId,
});

export const moveToStep3 = (extractionId) => ({
  type: actionTypes.MOVE_TO_STEP3,
  extractionId
});

export const viewFullData = (payload) => ({
  type: actionTypes.VIEW_FULL_DATA,
  payload
});

export const setSelectedVersion = (payload) => ({
  type: actionTypes.SET_SELECTED_VERSION,
  payload
});

export const getExtMetaData = (params) => ({
  type: actionTypes.GET_EXT_META_DATA,
  params,
});

export const getExtPincodeFromMaster = (pincode) => ({
  type: actionTypes.GET_EXT_PINCODE_FROM_MASTER,
  params: { pincode }
});

export const getExtProjectsForMaster = (masterProject) => ({
  type: actionTypes.GET_EXT_PROJECTS_FOR_MASTER,
  masterProject
});
